<script>
  import xyzSource from '../../mixin/xyz-source'

  const props = {}

  export default {
    name: 'vl-source-xyz',
    mixins: [xyzSource],
    props,
  }
</script>
